import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Switch } from "antd";
import { FormContentBlockerLayout } from "../..";
import { useI18n } from "../../../../../contexts";
const FormContentBlockerFieldIsVisual = ()=>{
    const { __ } = useI18n();
    return /*#__PURE__*/ _jsx(Form.Item, {
        wrapperCol: {
            offset: FormContentBlockerLayout.labelCol.span
        },
        children: /*#__PURE__*/ _jsxs("span", {
            children: [
                /*#__PURE__*/ _jsx(Form.Item, {
                    name: "isVisual",
                    valuePropName: "checked",
                    noStyle: true,
                    children: /*#__PURE__*/ _jsx(Switch, {})
                }),
                /*#__PURE__*/ _jsxs("span", {
                    children: [
                        "\xa0\xa0",
                        __("Show the visual content blocker, if possible")
                    ]
                })
            ]
        })
    });
};
export { FormContentBlockerFieldIsVisual };
